import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71578c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner fa-4x center-in-row"
}
const _hoisted_2 = { class: "sdds-col-md-4" }
const _hoisted_3 = { class: "custom-file" }
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "accept", "disabled"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"sdds-btn-icon btn-icon\" data-v-71578c5c><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" data-v-71578c5c><path d=\"M6 4a2 2 0 0 1 2-2h7.586A2 2 0 0 1 17 2.586L25.414 11A2 2 0 0 1 26 12.414V28a2 2 0 0 1-2 2h-6a1 1 0 1 1 0-2h6V13h-7a2 2 0 0 1-2-2V4H8v9a1 1 0 1 1-2 0V4Zm11 1.414V11h5.586L17 5.414Z\" fill=\"currentColor\" data-v-71578c5c></path><path d=\"M17.757 22.962a2 2 0 0 0 .07-1.784C16.469 18.166 13.512 16 10.004 16c-3.453 0-6.372 2.098-7.757 5.038a2 2 0 0 0-.07 1.783c1.357 3.013 4.314 5.178 7.822 5.178 3.453 0 6.373-2.098 7.758-5.037Zm-12.684.729a7.047 7.047 0 0 1-1.068-1.68L4 22h.005c0-.002.001-.003.002-.003C5.073 19.633 7.357 18 10.004 18c1.955 0 3.712.89 4.927 2.309a7.05 7.05 0 0 1 1.067 1.68l.005.011h-.005l-.001.003C14.93 24.366 12.646 26 9.999 26c-1.954 0-3.712-.891-4.926-2.31Z\" fill=\"currentColor\" data-v-71578c5c></path><path d=\"M12 22a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z\" fill=\"currentColor\" data-v-71578c5c></path></svg></span>", 1)

import { ref } from 'vue';
import { read, utils, WorkBook, } from 'xlsx';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileReader',
  props: {
  id: {
    type: String,
    default: 'customFile',
    required: true,
  },
  acceptType: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  fileType: {
    type: String,
    default: null,
    required: true,
  },
},
  emits: ['fileLoaded'],
  setup(__props, { emit }) {



// eslint-disable-next-line


const loadingFile = ref(false);

let base64StringFile: string = null;

const getColumns = (readFile: WorkBook) => {
  const result: string[] = [];
  const sheets = readFile.SheetNames;
  // console.log('sheets: ', sheets);
  const data = utils.sheet_to_json(readFile.Sheets[sheets[0]], { header: 1 });
  const headers = data[0];
  headers.forEach((header: string) => {
    result.push(header);
  });
  return result;
};

const getData = (readFile: WorkBook) => {
  const sheets = readFile.SheetNames;
  // console.log('sheets: ', sheets);
  const data = utils.sheet_to_json(readFile.Sheets[sheets[0]], {});
  return data;
};

const handleFileUpload = (event: Event) => {
  // console.log('event: ', event);
  const target = event.target as HTMLInputElement;
  const { files } = target;
  if ((files?.length ?? 0) === 0) return;

  const file = files[0];
  const reader = new FileReader();
  console.log('file: ', file.name);

  reader.onload = () => {
    try {
      loadingFile.value = true;
      base64StringFile = reader.result?.toString().replace('data:', '').replace(/^.+,/, '');
      const decodedStringAtoB = atob(base64StringFile);
      const readFile: WorkBook = read(decodedStringAtoB, { type: 'binary' });
      const columns = getColumns(readFile);
      const data = getData(readFile);
      const fileResult = {
        name: file.name, contents: data, columns, base64: base64StringFile,
      };
      emit('fileLoaded', fileResult);
    } catch (error) {
      console.error(`failed to convert file | ${error}`);
    } finally {
      loadingFile.value = false;
    }
  };
  reader.readAsDataURL(file);
  event.target.value = '';
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loadingFile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: "spinner",
            class: "fa-spin"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          class: _normalizeClass(["sdds-btn sdds-btn-primary btn-file", { 'disabled': __props.disabled }]),
          for: __props.id
        }, [
          _createTextVNode(_toDisplayString(__props.buttonLabel) + " ", 1),
          _createElementVNode("input", {
            id: __props.id,
            ref: "fileUpload",
            type: "file",
            accept: __props.acceptType,
            hidden: "",
            disabled: __props.disabled,
            onChange: handleFileUpload
          }, null, 40, _hoisted_5),
          _hoisted_6
        ], 10, _hoisted_4)
      ])
    ])
  ], 64))
}
}

})